import { render, staticRenderFns } from "./NoteModal.vue?vue&type=template&id=2a8dcc70&scoped=true"
import script from "./NoteModal.vue?vue&type=script&lang=js"
export * from "./NoteModal.vue?vue&type=script&lang=js"
import style0 from "./NoteModal.vue?vue&type=style&index=0&id=2a8dcc70&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8dcc70",
  null
  
)

export default component.exports